// extracted by mini-css-extract-plugin
module.exports = {"comp":"TC_comp__1pIAB"};